module.exports = __webpack_public_path__ + "img/way_f.af90a803.png";